var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small_icon"},[_c('icon',{staticClass:"icon",attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }